import moment from "moment";
import alBarka from "../assets/logos/al_barka_bank.png";
import alied from "../assets/logos/Allied-Bank-Logo.png";
import askari from "../assets/logos/ASKARI-BANK-logo.jpg";
import alFalah from "../assets/logos/Bank-Alfalah-Logo.png";
import alHabib from "../assets/logos/Bank-al-habib-logo.jpg";
import islami from "../assets/logos/bankislami-logo.png";
import citi from "../assets/logos/Citibank_logo.png";
import dubaiIslamic from "../assets/logos/Dubai-Islamic-Bank-logo.png";
import fysal from "../assets/logos/Faysal-Bank-logo.png";
import firstWomen from "../assets/logos/First-Women-Bank-logo.png";
import hblBank from "../assets/logos/HBL-logo.png";
import standardChartered from "../assets/logos/Standard-Chartered-Bank-logo.png";
import habibMetropolitan from "../assets/logos/Habib-Metropolitan-bank-logo.png";
import industrialCommercial from "../assets/logos/Industrial-and-Commercial-Bank-of-China-logo.png";
import js from "../assets/logos/JS-Bank-logo.png";
import mcbBank from "../assets/logos/MCB-Bank-logo.jpg";
import mcbIslamic from "../assets/logos/MCB-Islamic-Bank-logo.jpg";
import meezan from "../assets/logos/Meezan-Bank-logo.jpg";
import national from "../assets/logos/National-Bank-of-Pakistan-logo.png";
import punjab from "../assets/logos/Bank-of-Punjab-logo.jpg";
import sindh from "../assets/logos/Sindh-Bank-logo.jpg";
import khyber from "../assets/logos/The-Bank-of-Khyber-logo.png";
import zaraiTaraqiyati from "../assets/logos/Zarai-Taraqiyati-Bank-logo.png";
import samba from "../assets/logos/Samba-Bank-logo.jpg";
import silk from "../assets/logos/Silkbank-logo.jpg";
import soneri from "../assets/logos/Soneri-Bank-logo.png";
import summit from "../assets/logos/Summit-Bank-logo.png";
import ublLogo from "../assets/logos/UBL-logo.png";
import easyPaisa from "../assets/logos/EasyPaisa-logo.png";
import jazzCash from "../assets/images/jazz-cash.png";
import zong from "../assets/logos/Zong-PayMax-logo.png";
import keenu from "../assets/logos/Keenu-Wallet-logo.jpg";
import uPaisa from "../assets/logos/uPaisa-logo.png";
import ubl from "../assets/logos/UBL-Omni-logo.png";
import simSim from "../assets/logos/SimSim-logo.jpg";
import mcb from "../assets/logos/MCB-Mobile-logo.png";
import cashIcon from "../assets/icons/Cash_icon.svg";
import qz from "qz-tray";
import rs from "jsrsasign";

import { analytics, triggerLogEvent } from "../config/firebase";
import { formatNum } from "../oscar-pos-core/constants";
import uBIcon from "./../assets/icons/favicon2.png";
import {
  Bill,
  Charity,
  Entertainment,
  Fuel,
  GroceryFood,
  Health,
  Maintainces,
  Miscellaneous,
  MobilePackage,
  Rent,
  Transport,
} from "../assets/icons/icon";
let ENVIRONMENT = process.env.REACT_APP_ENV;

if (ENVIRONMENT === "PROD") {
  window.console.log = function () {};
}

export const camelCase = (input) => {
  const str = input == null ? "" : String(input);
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const sentenceCase = (input) => {
  const string = input == null ? "" : String(input);
  return string?.charAt(0).toUpperCase() + string?.slice(1).toLowerCase();
};

export const upperCase = (input) => {
  return input == null ? "" : String(input).toUpperCase();
};

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const REPORT_URL = process.env.REACT_APP_REPORT_URL;

export const App_Version = "10.2.5";

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const CHATWOOT_BASE_URl = process.env.REACT_APP_CHATWOOT_BASE_URL;
export const CHATWOOT_TOKEN = process.env.REACT_APP_CHATWOOT_TOKEN;
export const CHATWOOT_KEY = process.env.REACT_APP_CHATWOOT_KEY;

qz.security.setCertificatePromise(function (resolve, reject) {
  resolve(process.env.REACT_APP_QZ_CERTIFICATE.replace(/\\n/g, "\n"));
});

var privateKey = process.env.REACT_APP_QZ_PRIVATE_KEY.replace(/\\n/g, "\n");

qz.security.setSignaturePromise(function (toSign) {
  return function (resolve, reject) {
    try {
      var pk = rs.KEYUTIL.getKey(privateKey);
      var sig = new rs.KJUR.crypto.Signature({ alg: "SHA1withRSA" });
      sig.init(pk);
      sig.updateString(toSign);
      var hex = sig.sign();
      resolve(rs.stob64(rs.hextorstr(hex)));
    } catch (err) {
      console.error("eerrerer", err);
      reject(err);
    }
  };
});

export const uuid = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export var getSMSDivider = () => {
  // return Platform.OS === 'ios' ? '&' : '?';
};

const WEEK = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const getAttendanceFields = (journal) => {
  const requiredRes = journal.map(function (v) {
    return {
      payment: v.payment,
      id: v.id,
      attendance_at: new Date(v.attendance_at),
      status: v.status,
      journal_id: v.journal?.id,
    };
  });

  return requiredRes;
};

export const getJournalFields = (journal) => {
  const requiredRes = journal.map(function (v) {
    return {
      amount: v.amount,
      id: v.id,
      reference_id: v.reference_id,
      type: v.type,
      created_at: v.created_at,
    };
  });

  return requiredRes;
};

export const getStaffPayment = (action, single_staff, date) => {
  if (action === "Present") {
    if (single_staff.salary_type === "Monthly")
      return single_staff.salary / date.daysInMonth();
    else if (single_staff.salary_type === "Weekly")
      return single_staff.salary / 7;
    else if (single_staff.salary_type === "Daily")
      return Number(single_staff.salary);
    else if (single_staff.salary_type === "Hourly")
      return Number(single_staff.salary) * Number(single_staff.working_hours);
  } else if (action === "Absent") {
    if (!single_staff.workdays.includes(WEEK[moment(date).day()])) {
      if (single_staff.salary_type === "Monthly")
        return single_staff.salary / date.daysInMonth();
      else if (single_staff.salary_type === "Weekly")
        return single_staff.salary / 7;
      else if (single_staff.salary_type === "Daily")
        return Number(single_staff.salary);
    } else return 0;
  }
};

export var sanitizeWorkdays = (rawWorkdays) => {
  return Array.isArray(rawWorkdays) ? rawWorkdays.map(String) : [];
};

export const sanitizeOptions = (json) => json;

export var formatAMPM = (date) => {
  date = new Date(date);
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
};

export var getDateObj = (date) => {
  let today = new Date(date);
  let dd = String(today.getDate()).padStart(2, "0");
  let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  let yyyy = today.getFullYear();
  let obj = { day: dd, month: mm, year: yyyy };
  return obj;
};

export const getDateForCredithistory = (duration) => {
  let n = 0,
    obj = {};
  switch (duration) {
    case "Yesterday":
    case "گزشتہ روز":
    case "ڪالهه":
      n = 1;
      obj.startDate = new Date(
        new Date(new Date().setDate(new Date().getDate() - n)).setHours(
          0,
          0,
          0,
          0,
        ),
      );
      obj.endDate = new Date(
        new Date(new Date().setDate(new Date().getDate() - n)).setHours(
          23,
          59,
          0,
          0,
        ),
      );
      break;
    case "Last 7 Days":
    case "پچھلے 7 دن":
    case "گزريل ست ڏينھن":
      n = 7;
      obj.startDate = new Date(
        new Date(new Date().setDate(new Date().getDate() - n)).setHours(
          0,
          0,
          0,
          0,
        ),
      );
      obj.endDate = new Date(
        new Date(new Date().setDate(new Date().getDate() - 1)).setHours(
          23,
          59,
          0,
          0,
        ),
      );
      break;
    case "Last 30 Days":
    case "پچھلے 30 دن":
    case "آخري ٽي ڏينھن":
      n = 30;
      obj.startDate = new Date(
        new Date(new Date().setDate(new Date().getDate() - n)).setHours(
          0,
          0,
          0,
          0,
        ),
      );
      obj.endDate = new Date(
        new Date(new Date().setDate(new Date().getDate() - 1)).setHours(
          23,
          59,
          0,
          0,
        ),
      );
      break;
    case "Last Month":
    case "پچھلے مہینے":
    case "پوئين مھيني":
      var date1 = new Date();
      var firstDay = new Date(date1.getFullYear(), date1.getMonth() - 1, 1);
      var lastDay = new Date(date1.getFullYear(), date1.getMonth(), 0);
      obj.startDate = firstDay;
      obj.endDate = lastDay;
      // alert(firstDay + "===" + lastDay);
      break;
    default:
      obj.startDate = new Date(
        new Date(new Date().setDate(new Date().getDate() - 0)).setHours(
          0,
          0,
          0,
          0,
        ),
      );
      obj.endDate = new Date(
        new Date(new Date().setDate(new Date().getDate() - 0)).setHours(
          23,
          59,
          0,
          0,
        ),
      );
  }
  return obj;
};

export const DashDatedt = [
  // { showTill: "Last 7 days:", dataFrequency: "Daily", id: "7d" },
  { showTill: "View daily results:", dataFrequency: "Weekly", id: "7d" },
  {
    showTill: "View last 4 weeks results:",
    dataFrequency: "Monthly",
    id: "30d",
  },
  { showTill: "Last 12 month:", dataFrequency: "Yearly", id: "365d" },
];

export const dataFilters = {
  Weekly: {
    value: 7,
    unit: "days",
    startOf: "day",
    endOf: "day",
    labelFormat: "ddd",
    limit: 7,
  },
  Monthly: {
    value: 4,
    unit: "weeks",
    startOf: "week",
    endOf: "week",
    labelFormat: "[Week] W",
    limit: 3,
  },
  Yearly: {
    value: 12,
    unit: "months",
    startOf: "month",
    endOf: "month",
    labelFormat: "MMM",
    limit: 11,
  },
};

export const getNewGroupByMonths = () => {
  return JSON.parse(
    JSON.stringify({
      Jan: [],
      Feb: [],
      Mar: [],
      Apr: [],
      May: [],
      Jun: [],
      Jul: [],
      Aug: [],
      Sep: [],
      Oct: [],
      Nov: [],
      Dec: [],
    }),
  );
};
export const defaultFilterTabOptions = {
  dt: "dt_all",
  tr: "tr_all",
  ld: "ld_all",
  srt: "srt_new",
};

export const isValidRendertype = (type) => {
  //Check if type is renderable
  const str = typeof "";
  const num = typeof 5;
  const bool = typeof true;
  return type === str || type === num || type === bool;
};

const objectFromArray = (arr = []) =>
  arr.reduce((obj, item) => {
    obj[item] = [];
    return JSON.parse(JSON.stringify(obj));
  }, {});

const getNewGroupByQuarter = () => {
  const dt = new Date();
  const curr_month = dt.getMonth();
  const current_year = dt.getFullYear();
  let XAxisVals = [];
  if (curr_month >= 0 && curr_month < 3) {
    XAxisVals = ["Oct", "Nov", "Dec"].map((m) => `${m} ${current_year - 1}`);
  } else if (curr_month >= 3 && curr_month < 6) {
    XAxisVals = ["Jan", "Feb", "Mar"].map((m) => `${m} ${current_year}`);
  } else if (curr_month >= 6 && curr_month < 9) {
    XAxisVals = ["Apr", "May", "Jun"].map((m) => `${m} ${current_year}`);
  } else if (curr_month >= 9 && curr_month < 12) {
    XAxisVals = ["Jul", "Aug", "Sept"].map((m) => `${m} ${current_year}`);
  }
  return objectFromArray(XAxisVals);
};

const getNewGroupByWeek = () => {
  const dt = new Date();
  let curr_month = dt.getMonth();
  let prev_month = (curr_month - 1 + 12) % 12;
  const lastMonth = MONTHS_LOWERCASE[prev_month];
  let XAxisVals = [1, 2, 3, 4].map((l) => `${lastMonth} W${l}`);
  return objectFromArray(XAxisVals);
};
const getNewGroupByDay = () => {
  let currentDate = moment();
  let daily_Arr = [];
  for (let i = 7; i >= 1; i--) {
    let date = currentDate.clone().subtract(i, "days");
    daily_Arr.push(date.format("ddd,DD MMM"));
  }
  return objectFromArray(daily_Arr);
};

export const checkValueGroup = (transactionTime, freq = "Yearly") => {
  switch (freq.toLowerCase()) {
    case "yearly":
      return MONTHS_LOWERCASE[moment(transactionTime).month()];
    case "monthly":
      return moment(transactionTime).format("MMM YYYY");
    case "weekly":
      const day = moment(transactionTime).date();
      let weekNum = Math.min(Math.ceil(day / 7), 4);
      return `${MONTHS_LOWERCASE[moment(transactionTime).month()]} W${weekNum}`;
    case "daily":
      return moment(transactionTime).format("ddd,DD MMM");
    default:
      return;
  }
};

/* Uses CSS variables for theme colors */
export var themeStyleSheet = {
  red: "var(--themeRed)",
  skyBlue: "var(--themeSkyBlue)",
  blueShade: "var(--blueShade)",
  mustardYellow: "var(--themeMustardYellow)",
  extraLightGray: "var(--extraLightGray)",
  lightGray: "var(--lightGray)",
  lightGreen: "var(--themeLightGreen)",
  mediumGray: "var(--mediumGray)",
  darkGray: "var(--darkGray)",
  darkGreen: "var(--darkGreen)",
  darkOrange: "var(--darkOrange)",
  brightGreen: "var(--brightGreen)",
  brightOrange: "var(--brightOrange)",
  mainColor: "var(--themeMainColor)",
  white: "var(--white)",
  extraBrightRed: "var(--themeExtraBrightRed)",
  lightOrange: "var(--themeLightOrange)",
  black: "var(--themeBlack)",
};

export const MONTHS = [
  "JANUARY",
  "FEBRUARY",
  "MARCH",
  "APRIL",
  "MAY",
  "JUNE",
  "JULY",
  "AUGUST",
  "SEPTEMBER",
  "OCTOBER",
  "NOVEMBER",
  "DECEMBER",
];

export const MONTHS_LOWERCASE = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const formateDate_dd_month_yy_lower = (date) => {
  date = new Date(date);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let current_datetime = new Date(date);
  let formatted_date =
    current_datetime.getDate() +
    " " +
    months[current_datetime.getMonth()] +
    " " +
    current_datetime.getFullYear();
  return formatted_date;
};

export const formateDate_dd_month = (date) => {
  date = new Date(date);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let current_datetime = new Date(date);
  let formatted_date =
    current_datetime.getDate() + " " + months[current_datetime.getMonth()];
  return formatted_date;
};

export const formateDate_dd_month_yy = (date) => {
  date = new Date(date);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let current_datetime = new Date(date);
  let formatted_date =
    current_datetime.getDate() +
    " " +
    months[current_datetime.getMonth()] +
    " " +
    current_datetime.getFullYear();
  return formatted_date;
};

export const getPrint = (data, pos = false) => {
  let total = 0;
  if (!data.items.length) {
    total = data?.amount || data?.invoice?.amount;
  }

  const invoiceToPrint = `
  <html>
    <head>
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Inconsolata:wght@200;300;400;500;600&display=swap" rel="stylesheet">
  
    <style>
    body {
      font-family: 'Inconsolata', monospace;
      color: #000;
      width:100%';
    }
    .billDetail{
      display: flex;
      flex-direction: row;
      justify-content: space-between:
      width:100%';
    }
    .billDetailInner{
      display: flex;
      flex-direction: column;
      width: 50%;
      padding: 0 8px 0 0;
      justify-content: flex-start;
    }
    .billDetailInnerRight{
      align-items: flex-end;
      padding: 0;
      text-align: right;
    }
    .billDetailInnerRight p {
      line-height: 20px;
    }
    .billDetailInnerRight p:nth-child(1) {
      margin-bottom: 5px;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      display: -webkit-box;
  }
    .billDetailInner p {
      margin: 0 0 8px;
    }
    .billDetailInner p span{
      font-size: 13px;
    }
    .customerDetail {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 6px 0 8px;
      margin: 5px 0 0;
    }
    .customerDetail p{
      text-align: center;
      margin: 0;
    }
    .customerDetail p:nth-child(1){
      margin-bottom: 5px;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      display: -webkit-box;
    }
    .customerDetail p span{
      font-size: 13px;
    }
    .itemDetailHeader{
      display: grid;
      grid-template-columns: 0.5fr 3fr 2fr;
      gap: 10px;
      border-bottom: 1px dashed #000;
      margin-bottom: 5px;
      padding: 10px 0;
      width: 100%;
    }
    .itemDetailBodyMain{
      margin-bottom: 20px;
      width: 100%;
    }
    .itemDetailBody{
      display: grid;
      grid-template-columns: 0.5fr 3fr 2fr;
      gap: 5px 10px;
      padding: 7px 0;
    }
    .itemQuantityHeader{
      text-align: center;
      margin: 0;
      font-size: 14px;
      font-weight: 600;
    }
    .itemNameHeader{
      text-align: left;
      /* border: 1px solid #000; */
      margin: 0;
      font-size: 14px;
      font-weight: 600;
    }
    .itemNameHeader b{
      font-weight: 400;
    }
   .itemPriceHeader{
      text-align: right;
      /* border: 1px solid #000; */
      margin: 0;
      font-size: 14px;
      font-weight: 600;
   }
    .itemQuantity{
      text-align: center;
      font-size: 13px;
      margin: 0;
    }
    .itemName{
      text-align: left;
      font-size: 13px;
      margin: 0;
      /* border: 1px solid #000; */
    }
   .itemPrice{
      text-align: right;
      font-size: 13px;
      margin: 0;
      /* border: 1px solid #000; */
   }
   .totalSection{
      display: grid;
      grid-template-columns: repeat(2,2fr);
      gap: 15px;
      border-top: 1px dashed #000;
      padding: 20px 0;
      width: 100%;
   }
   .totalSection p{
      margin: 0 0 0px;
      font-size: 15px
  }
  .totalSection p:nth-child(2){
      text-align: right;
  }
  .totalSectionOnly{
    display: grid;
    grid-template-columns: repeat(2,2fr);
    gap: 15px;
    border-top: 1px dashed #000;
    padding: 20px 0;
    margin-top: 30px;
 }
 .totalSectionOnly p{
    margin: 0 0 0px;
    font-size: 15px
}
.totalSectionOnly p:nth-child(2){
    text-align: right;
}
  .recieptFooter{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 10px 0 50px;
      padding: 8px 0 30px;
  }
  .recieptFooter p{
      margin: 3px 0 3px;
      font-size: 13px;
  }
  .poweredByCont{
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
  }
  .poweredByCont span{
      padding: 0 1px;
  }
  .poweredByCont span:nth-child(2){
      position: relative;
      top: 3px;
  }
  .poweredByCont span:nth-child(4) {
      position: relative;
      top: 2px;
  }
      </style>
    </head>
    <body>
      
    <div class="billDetail">
        <div class="billDetailInner">
            <p>
              <span>
                Date:
              </span>
              <span>
              ${formateDate_dd_month_yy(data?.date)}
              </span>
            </p>
            <p>
              <span>
                Time:
              </span>
              <span>
              ${formatAMPM(data?.date)}
              </span>
            </p>
        </div>

          <div class="billDetailInner billDetailInnerRight">
            <p>
              <span>
                From:
              </span>
              <span>
              ${data.business.name}  
              </span>
            </p>
          </div>
      </div>   

      ${
        data?.customer?.name || data?.customer?.phone
          ? `<div class="customerDetail">
          ${
            data?.customer?.name
              ? `<p>
                  <span>Customer Name:</span>
                  <span>${data?.customer?.name}</span>
              </p>`
              : ""
          }
            ${
              data?.customer?.phone
                ? `<p>
                  <span>
                      Customer Phone #:
                  </span>
                  <span>
                  ${data?.customer?.phone}
                  </span>
              </p>`
                : ""
            }
        </div>`
          : ""
      }

    ${
      data.items.length
        ? `<div>
        <div class="itemDetailHeader">
            <p class="itemQuantityHeader">
                Qty
            </p>
            <p class="itemNameHeader">
                Item<b>(s)</b>
            </p>
            <p class="itemPriceHeader">
                Total
            </p>
        </div>
        
        <div class="itemDetailBodyMain">
          ${data.items
            .map((item, index) => {
              total += (item.selling_price ?? item.price) * item.quantity;
              return `<div class="itemDetailBody" key={${index}}>
                <p class="itemQuantity">${item.quantity}</p>
                <p class="itemName">${item.name || item.product_name}</p>
                <p class="itemPrice">Rs. ${formatNum(
                  (item.selling_price ?? item.price) * item.quantity,
                )}</p>
            </div>`;
            })
            .join("")}
        </div>
      </div>`
        : ""
    }
      
      <div class=${data.items.length ? "totalSection" : "totalSectionOnly"}>
          <p>SUB TOTAL</p>
          <p>Rs. ${formatNum(data?.subTotal ?? total)}</p>
      </div>

      <div class="totalSection">
          <p>TOTAL</p>
          <p>Rs. ${formatNum(pos ? data?.amount : total)}</p>
      </div>

      <div class="recieptFooter">
          <p>
              Thank you for visiting us.                
          </p>
          <div class="poweredByCont">
              <span>We're</span>
              <span>
                  <svg 
                  fill="#000"
                    height="16"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px"
                          viewBox="0 0 18 18" style="enable-background:new 0 0 16 16;">
                      <style type="text/css">
                          .st0{fill:#000;}
                      </style>
                      <path class="st0" d="M-98.4,213.85c-16.6,23.12-33.29,46.17-49.91,69.16c-4.22-0.12-3.57-2.53-2.88-5.09
                          c3.74-13.81,7.45-27.63,11.15-41.44c0.33-1.24,0.56-2.51,0.93-4.2c-7.73,0-15.05,0.07-22.36-0.03c-3.77-0.05-5.07-1.97-3.16-4.98
                          c14.78-23.32,29.68-46.57,44.47-69.72c3.6,0.08,3.85,1.71,3.39,4.57c-2.46,15.11-4.68,30.26-7.1,46.15c7.94,0,15.25-0.07,22.55,0.07
                          c1.3,0.03,3.21,0.62,3.69,1.55C-97.14,210.84-97.65,212.81-98.4,213.85z"/>
                      <path d="M914.03,247.79c7.94,0,15.24-0.07,22.55,0.07c1.3,0.03,3.21,0.62,3.69,1.55c0.49,0.96-0.02,2.92-0.76,3.96
                          c-16.6,23.12-33.29,46.18-49.91,69.17c-4.22-0.12-3.58-2.53-2.88-5.1c3.74-13.81,7.44-27.62,11.15-41.44
                          c0.33-1.24,0.56-2.51,0.93-4.2c-7.74,0-15.05,0.07-22.36-0.03c-3.77-0.05-5.07-1.97-3.16-4.98c14.79-23.32,29.69-46.57,44.47-69.72
                          c3.6,0.08,3.85,1.71,3.39,4.57C918.67,216.75,916.45,231.89,914.03,247.79z M877.3,267.8c6.86,0,12.66,0,18.47,0
                          c8.28,0,8.42,0.2,6.29,8.1c-2.99,11.12-5.94,22.25-8.91,33.38c0.28,0.12,0.56,0.23,0.84,0.35c13.74-19.04,27.48-38.08,41.74-57.83
                          c-5.43,0-9.74-0.01-14.05,0c-13.66,0.02-12.56,1.11-10.42-12.44c1.56-9.93,3.01-19.87,4.51-29.81c-0.33-0.13-0.66-0.26-0.99-0.38
                          C902.48,228.41,890.17,247.66,877.3,267.8z"/>
                      <path d="M166.47,209.89c-0.48-0.93-2.39-1.52-3.69-1.55c-7.3-0.14-14.61-0.07-22.55-0.07c2.42-15.89,4.64-31.04,7.1-46.15
                          c0.46-2.86,0.21-4.49-3.39-4.57c-14.79,23.15-29.69,46.4-44.47,69.72c-1.91,3.01-0.61,4.93,3.16,4.98
                          c7.31,0.1,14.63,0.03,22.36,0.03c-0.37,1.69-0.6,2.96-0.93,4.2c-3.7,13.81-7.41,27.63-11.15,41.44c-0.69,2.56-1.34,4.97,2.88,5.09
                          c16.62-22.99,33.31-46.04,49.91-69.16C166.45,212.81,166.96,210.84,166.47,209.89z M120.2,270.11c-0.28-0.12-0.57-0.24-0.85-0.35
                          c2.97-11.13,5.92-22.26,8.91-33.38c2.13-7.9,2-8.1-6.29-8.1H103.5c12.88-20.14,25.18-39.39,37.48-58.63
                          c0.33,0.12,0.66,0.25,0.99,0.38c-1.5,9.94-2.95,19.88-4.51,29.81c-2.14,13.55-3.25,12.46,10.42,12.44c4.31-0.01,8.62,0,14.05,0
                          C147.68,232.02,133.94,251.07,120.2,270.11z"/>
                      <path class="st0" d="M166.47,209.89c-0.48-0.93-2.39-1.52-3.69-1.55c-7.3-0.14-14.61-0.07-22.55-0.07
                          c2.42-15.89,4.64-31.04,7.1-46.15c0.46-2.86,0.21-4.49-3.39-4.57c-14.79,23.15-29.69,46.4-44.47,69.72
                          c-1.91,3.01-0.61,4.93,3.16,4.98c7.31,0.1,14.63,0.03,22.36,0.03c-0.37,1.69-0.6,2.96-0.93,4.2c-3.7,13.81-7.41,27.63-11.15,41.44
                          c-0.69,2.56-1.34,4.97,2.88,5.09c16.62-22.99,33.31-46.04,49.91-69.16C166.45,212.81,166.96,210.84,166.47,209.89z M120.2,270.11
                          c-0.28-0.12-0.57-0.24-0.85-0.35c2.97-11.13,5.92-22.26,8.91-33.38c2.13-7.9,2-8.1-6.29-8.1H103.5
                          c12.88-20.14,25.18-39.39,37.48-58.63c0.33,0.12,0.66,0.25,0.99,0.38c-1.5,9.94-2.95,19.88-4.51,29.81
                          c-2.14,13.55-3.25,12.46,10.42,12.44c4.31-0.01,8.62,0,14.05,0C147.68,232.02,133.94,251.07,120.2,270.11z"/>
                      <path class="st0" d="M12.12,6.74c-0.06-0.11-0.29-0.18-0.45-0.19c-0.89-0.02-1.78-0.01-2.74-0.01c0.29-1.93,0.56-3.78,0.86-5.61
                          c0.06-0.35,0.03-0.55-0.41-0.56c-1.8,2.82-3.61,5.64-5.41,8.48c-0.23,0.37-0.07,0.6,0.38,0.61c0.89,0.01,1.78,0,2.72,0
                          C7.03,9.67,7,9.82,6.96,9.97c-0.45,1.68-0.9,3.36-1.36,5.04c-0.08,0.31-0.16,0.6,0.35,0.62c2.02-2.8,4.05-5.6,6.07-8.41
                          C12.11,7.09,12.18,6.85,12.12,6.74z"/>
                      <path d="M-97.63,209.89c-0.48-0.93-2.39-1.52-3.69-1.55c-7.3-0.14-14.61-0.07-22.55-0.07c2.42-15.89,4.64-31.04,7.1-46.15
                          c0.46-2.86,0.21-4.49-3.39-4.57c-14.79,23.15-29.69,46.4-44.47,69.72c-1.91,3.01-0.61,4.93,3.16,4.98
                          c7.31,0.1,14.63,0.03,22.36,0.03c-0.37,1.69-0.6,2.96-0.93,4.2c-3.7,13.81-7.41,27.63-11.15,41.44c-0.69,2.56-1.34,4.97,2.88,5.09
                          c16.62-22.99,33.31-46.04,49.91-69.16C-97.65,212.81-97.14,210.84-97.63,209.89z M-143.9,270.11c-0.28-0.12-0.57-0.24-0.85-0.35
                          c2.97-11.13,5.92-22.26,8.91-33.38c2.13-7.9,2-8.1-6.29-8.1h-18.47c12.88-20.14,25.18-39.39,37.48-58.63
                          c0.33,0.12,0.66,0.25,0.99,0.38c-1.5,9.94-2.95,19.88-4.51,29.81c-2.14,13.55-3.25,12.46,10.42,12.44c4.31-0.01,8.62,0,14.05,0
                          C-116.42,232.02-130.16,251.07-143.9,270.11z"/>
                          <path class="st0" d="M36.09,7.22c-2.02,2.82-4.06,5.63-6.09,8.43c-0.51-0.01-0.44-0.31-0.35-0.62c0.46-1.68,0.91-3.37,1.36-5.05
                              c0.04-0.15,0.07-0.31,0.11-0.51c-0.94,0-1.84,0.01-2.73,0c-0.46-0.01-0.62-0.24-0.39-0.61c1.8-2.84,3.62-5.68,5.42-8.5
                              c0.44,0.01,0.47,0.21,0.41,0.56c-0.3,1.84-0.57,3.69-0.87,5.63c0.97,0,1.86-0.01,2.75,0.01c0.16,0,0.39,0.08,0.45,0.19
                              C36.24,6.85,36.18,7.09,36.09,7.22z"/>
                          <path d="M36.18,6.73c-0.06-0.11-0.29-0.19-0.45-0.19c-0.89-0.02-1.78-0.01-2.75-0.01c0.3-1.94,0.57-3.78,0.87-5.63
                              c0.06-0.35,0.03-0.55-0.41-0.56c-1.8,2.82-3.62,5.66-5.42,8.5c-0.23,0.37-0.07,0.6,0.39,0.61c0.89,0.01,1.78,0,2.73,0
                              c-0.05,0.21-0.07,0.36-0.11,0.51c-0.45,1.68-0.9,3.37-1.36,5.05c-0.08,0.31-0.16,0.61,0.35,0.62c2.03-2.8,4.06-5.61,6.09-8.43
                              C36.18,7.09,36.24,6.85,36.18,6.73z M30.54,14.08c-0.03-0.01-0.07-0.03-0.1-0.04c0.36-1.36,0.72-2.71,1.09-4.07
                              c0.26-0.96,0.24-0.99-0.77-0.99H28.5c1.57-2.46,3.07-4.8,4.57-7.15c0.04,0.01,0.08,0.03,0.12,0.05c-0.18,1.21-0.36,2.42-0.55,3.64
                              c-0.26,1.65-0.4,1.52,1.27,1.52c0.53,0,1.05,0,1.71,0C33.89,9.43,32.22,11.75,30.54,14.08z"/>
                  </svg>

                </span>
                <span>by</span>
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
 width="85.631px" height="26px" viewBox="0 0 85.631 26" enable-background="new 0 0 85.631 26">
  <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="37.0029" y1="12.7539" x2="46.5366" y2="12.7539">
    <stop  offset="0.3498" style="stop-color: #000"/>
    <stop  offset="1" style="stop-color:ref"/>
  </linearGradient>
  <path fill="url(#SVGID_1_)" d="M46.535,14.272c0.033,1.334-0.444,2.486-1.431,3.457c-0.988,0.971-2.147,1.435-3.481,1.392
    c-1.292-0.033-2.384-0.521-3.278-1.465c-0.895-0.943-1.342-2.066-1.342-3.367c0-1.355,0.481-2.518,1.445-3.489
    c0.963-0.971,2.109-1.434,3.441-1.391c1.364,0.055,2.5,0.602,3.409,1.643V6.384h1.236V14.272z M45.299,14.175
    c-0.021-0.981-0.367-1.819-1.035-2.517s-1.481-1.046-2.438-1.046c-0.978-0.01-1.819,0.335-2.52,1.038
    c-0.701,0.702-1.057,1.55-1.067,2.541c-0.011,0.98,0.316,1.838,0.979,2.573s1.472,1.119,2.429,1.152
    c1.022,0.055,1.894-0.3,2.617-1.063C44.986,16.091,45.332,15.199,45.299,14.175z"/>
  <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="47.8369" y1="12.5898" x2="56.0186" y2="12.5898">
    <stop  offset="0.3498" style="stop-color: #000"/>
    <stop  offset="1" style="stop-color: #000"/>
  </linearGradient>
  <path fill="url(#SVGID_2_)" d="M56.019,18.86h-1.236v-5.401c0-0.78-0.29-1.455-0.869-2.024c-0.581-0.569-1.258-0.844-2.035-0.822
    c-0.787,0.011-1.452,0.274-1.993,0.789c-0.542,0.516-0.813,1.169-0.813,1.961v5.498h-1.235V6.318h1.235v4.587
    c0.707-0.921,1.615-1.409,2.723-1.464c1.152-0.054,2.144,0.325,2.976,1.139s1.248,1.816,1.248,3.01V18.86z"/>
  <linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="57.1899" y1="14.2148" x2="66.7251" y2="14.2148">
    <stop  offset="0.3498" style="stop-color: #000"/>
    <stop  offset="1" style="stop-color: #000"/>
  </linearGradient>
  <path fill="url(#SVGID_3_)" d="M66.722,14.208v0.064v4.588h-1.236v-1.447c-1.005,1.149-2.236,1.701-3.694,1.658
    c-1.275-0.043-2.361-0.537-3.257-1.479c-0.896-0.943-1.345-2.066-1.345-3.367c0-1.356,0.482-2.52,1.448-3.489
    c0.965-0.972,2.121-1.43,3.465-1.375c1.302,0.044,2.408,0.539,3.319,1.489C66.332,11.798,66.765,12.917,66.722,14.208z
     M65.486,14.117c-0.022-0.978-0.37-1.814-1.044-2.51c-0.673-0.695-1.483-1.044-2.429-1.044c-0.989,0-1.832,0.349-2.527,1.044
    s-1.049,1.538-1.06,2.527c-0.022,0.979,0.302,1.834,0.97,2.567s1.476,1.122,2.421,1.165c1.022,0.045,1.894-0.312,2.617-1.068
    C65.157,16.044,65.507,15.15,65.486,14.117z"/>
  <linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="68.0073" y1="14.2148" x2="77.5425" y2="14.2148">
    <stop  offset="0.3498" style="stop-color: #000"/>
    <stop  offset="1" style="stop-color: #000"/>
  </linearGradient>
  <path fill="url(#SVGID_4_)" d="M77.54,14.208v0.064v4.588h-1.236v-1.447c-1.004,1.149-2.236,1.701-3.694,1.658
    c-1.274-0.043-2.36-0.537-3.257-1.479c-0.897-0.943-1.345-2.066-1.345-3.367c0-1.356,0.482-2.52,1.448-3.489
    c0.965-0.972,2.121-1.43,3.464-1.375c1.302,0.044,2.408,0.539,3.319,1.489C77.149,11.798,77.583,12.917,77.54,14.208z
     M76.303,14.117c-0.021-0.978-0.37-1.814-1.044-2.51s-1.483-1.044-2.428-1.044c-0.99,0-1.832,0.349-2.528,1.044
    c-0.696,0.695-1.049,1.538-1.06,2.527c-0.022,0.979,0.302,1.834,0.97,2.567c0.669,0.733,1.476,1.122,2.421,1.165
    c1.022,0.045,1.894-0.312,2.617-1.068C75.975,16.044,76.325,15.15,76.303,14.117z"/>
  <linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="78.7432" y1="14.1328" x2="82.4849" y2="14.1328">
    <stop  offset="0.3498" style="stop-color: #000"/>
    <stop  offset="1" style="stop-color: #000"/>
  </linearGradient>
  <path fill="url(#SVGID_5_)" d="M82.485,10.646c-0.575,0.021-1.042,0.179-1.399,0.473c-0.357,0.292-0.602,0.546-0.732,0.764
    c-0.206,0.358-0.309,0.835-0.309,1.431v5.548h-1.302V9.588h1.155v1.317c0.26-0.498,0.645-0.883,1.155-1.154
    c0.466-0.25,0.943-0.363,1.432-0.342V10.646z"/>
  <linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="27.6816" y1="14.2188" x2="35.8804" y2="14.2188">
    <stop  offset="0.3498" style="stop-color: #000"/>
    <stop  offset="1" style="stop-color: #000"/>
  </linearGradient>
  <path fill="url(#SVGID_6_)" d="M35.88,14.875c0,1.204-0.388,2.206-1.163,3.009s-1.754,1.204-2.936,1.204
    c-1.182,0-2.161-0.401-2.937-1.204c-0.775-0.803-1.163-1.805-1.163-3.009V9.351h1.236v5.681c0,0.783,0.287,1.454,0.859,2.014
    c0.573,0.56,1.241,0.839,2.004,0.839c0.763,0,1.431-0.279,2.004-0.839s0.859-1.23,0.859-2.014V9.351h1.236V14.875z"/>

<linearGradient id="SVGID_7_" gradientUnits="userSpaceOnUse" x1="2.7681" y1="12.7031" x2="23.1284" y2="12.7031">
  <stop  offset="0.3498" style="stop-color: #000"/>
  <stop  offset="1" style="stop-color: #000"/>
</linearGradient>
<path fill="url(#SVGID_7_)" d="M12.949,2.521c-5.623,0-10.181,4.559-10.181,10.181s4.559,10.182,10.181,10.182
  c5.622,0,10.179-4.56,10.179-10.182S18.571,2.521,12.949,2.521z M15.292,8.762c0.025-0.248,0.126-0.468,0.318-0.663
  c0.163-0.168,0.346-0.27,0.555-0.312h1.323v2.209h-1.096c-0.306,0-0.562-0.111-0.782-0.336c-0.191-0.195-0.293-0.415-0.318-0.664
  V8.762z M8.329,7.787h1.324c0.208,0.042,0.391,0.144,0.554,0.312c0.191,0.195,0.292,0.415,0.317,0.663v0.234
  C10.5,9.245,10.399,9.465,10.208,9.66c-0.22,0.225-0.476,0.336-0.782,0.336H8.329V7.787z M16.189,17.133
  c-0.865,0.896-1.969,1.35-3.281,1.35s-2.416-0.453-3.281-1.35c-0.862-0.892-1.298-2.016-1.298-3.343v-2.767l2.196-0.002
  c0,0,0.004,3.087,0.012,3.165c0.052,0.55,0.282,1.019,0.703,1.43c0.483,0.473,1.029,0.703,1.669,0.703
  c0.639,0,1.185-0.23,1.668-0.703c0.3-0.293,0.504-0.616,0.615-0.978c0.066-0.217,0.099-0.445,0.099-0.691v-2.926l2.196,0.002v2.767
  C17.487,15.117,17.052,16.241,16.189,17.133z"/>

</svg>
                </span>
          </div>
      </div>

    </body>
  </html>`;

  let options = {
    rasterize: false,
    scaleContent: false,
    density: "2",
  };
  let config = qz.configs.create(data.printer, options);
  let printFormat = [
    {
      type: "pixel",
      format: "html",
      flavor: "plain",
      data: invoiceToPrint,
    },
  ];
  // return new Promise((resolve, reject) => {
  if (!qz.websocket.isActive()) {
    qz.websocket
      .connect()
      .then(() => {
        qz.print(config, printFormat);
      })
      .then(() => {
        triggerLogEvent(
          analytics,
          pos ? "receipt_printed_from_pos" : "receipt_printed",
        );
        qz.websocket.disconnect();
        // resolve(true);
      })
      .catch((err) => {
        triggerLogEvent(analytics, "printer_unable_to_connect");
        console.error("ERROR", err);
        // reject(true);
      });
  } else {
    qz.print(config, printFormat)
      .then((res) => {
        triggerLogEvent(
          analytics,
          pos ? "receipt_printed_from_pos" : "receipt_printed",
        );
        // resolve(true);
      })
      .catch(() => {
        // reject(true);
      });
  }
  // })
};
export const getSerailNumber = (num) => {
  let n = Math.abs(Math.floor(num));
  return n > 9 ? `${n}` : `0${n}`;
};
export const UNITS = [
  {
    name: "Pcs",
  },
  {
    name: "kg",
  },
  {
    name: "gm",
  },
  {
    name: "ltr",
  },
  {
    name: "ml",
  },
  {
    name: "bags",
  },
  {
    name: "tola",
  },
  {
    name: "foot",
  },
  {
    name: "box",
  },
  {
    name: "packet",
  },
  {
    name: "carten",
  },
  {
    name: "dozen",
  },
  {
    name: "rim",
  },
  {
    name: "bottle",
  },
  {
    name: "bundle",
  },
  {
    name: "pound",
  },
  {
    name: "rool",
  },
  {
    name: "gallon",
  },
  {
    name: "quarter",
  },
  {
    name: "caan",
  },
  {
    name: "thaan",
  },
];

export var banks = [
  {
    name: "Al Baraka Bank",
    image: alBarka,
  },
  {
    name: "Allied Bank",
    image: alied,
  },
  {
    name: "Askari Islamic Bank",
    image: askari,
  },
  {
    name: "Bank Alfalah",
    image: alFalah,
  },
  {
    name: "Bank Al-Habib",
    image: alHabib,
  },
  {
    name: "BankIslami",
    image: islami,
  },
  {
    name: "Citi Bank",
    image: citi,
  },
  {
    name: "Dubai Islamic Bank",
    image: dubaiIslamic,
  },
  {
    name: "Faysal Bank",
    image: fysal,
  },
  {
    name: "Jazz Cash Bank",
    image: jazzCash,
  },
  {
    name: "First Women Bank",
    image: firstWomen,
  },
  {
    name: "HBL",
    image: hblBank,
  },
  {
    name: "Standard Chartered Bank",
    image: standardChartered,
  },
  {
    name: "Habib Metropolitan",
    image: habibMetropolitan,
  },
  {
    name: "Industrial and Commercial Bank of China",
    image: industrialCommercial,
  },
  {
    name: "JS Bank",
    image: js,
  },
  {
    name: "MCB Bank",
    image: mcbBank,
  },
  {
    name: "MCB Islamic Bank",
    image: mcbIslamic,
  },
  {
    name: "Meezan Bank",
    image: meezan,
  },
  {
    name: "National Bank of Pakistan",
    image: national,
  },
  {
    name: "Bank of Punjab",
    image: punjab,
  },
  {
    name: "Sindh Bank",
    image: sindh,
  },
  {
    name: "Bank of Khyber",
    image: khyber,
  },
  {
    name: "Zarai Taraqiyati Bank",
    image: zaraiTaraqiyati,
  },
  {
    name: "Samba Bank",
    image: samba,
  },
  {
    name: "Silkbank",
    image: silk,
  },
  {
    name: "Soneri Bank",
    image: soneri,
  },
  {
    name: "Summit Bank",
    image: summit,
  },
  {
    name: "UBL",
    image: ublLogo,
  },
];

export var wallets = [
  {
    name: "EasyPaisa",
    image: easyPaisa,
  },
  {
    name: "JazzCash",
    image: jazzCash,
  },
  {
    name: "Zong PayMax",
    image: zong,
  },
  {
    name: "Keenu Wallet",
    image: keenu,
  },
  {
    name: "uPaisa",
    image: uPaisa,
  },
  {
    name: "UBL Omni",
    image: ubl,
  },
  {
    name: "SimSim",
    image: simSim,
  },
  {
    name: "MCB Mobile",
    image: mcb,
  },
];

export const updatedPaymentMethods = [
  {
    name: "bank",
    display_name: "Bank",
    type: "bank",
  },
  {
    name: "cash",
    display_name: "Cash",
    type: "cash",
  },
];

export const PaymentMethods = [
  ...wallets.map((d) => ({ ...d, display_name: d.name, type: "wallet" })),
  ...banks.map((d) => ({ ...d, display_name: d.name, type: "bank" })),
  {
    name: "cash",
    display_name: "Cash",
    type: "cash",
    image: cashIcon,
  },
  {
    name: "ucash",
    display_name: "UB Wallet",
    type: "wallet",
    image: uBIcon,
  },
];

export const fewPaymentMethods = [
  {
    name: "cash",
    display_name: "Cash",
    type: "cash",
  },
  {
    name: "udhaar",
    display_name: "Udhaar",
    type: "udhaar",
  },
];

const popularList = ["jazzcash", "easypaisa", "cash", "ucash"];
export const getPopularMethods = () => {
  const popularFilter = PaymentMethods.filter((bank) =>
    popularList.includes(bank?.name?.toLowerCase()),
  );
  return {
    Popular: { title: "Popular", data: popularFilter },
  };
};
export const getMethodsGroupedByLetter = (methodList = PaymentMethods) => {
  const popularMethods = PaymentMethods.filter((bank) =>
    popularList.includes(bank?.name?.toLowerCase()),
  );
  const restMethods = methodList.filter(
    (bank) => !popularList.includes(bank?.name?.toLowerCase()),
  );
  const groupedMethods = {};
  restMethods.map((method) => {
    const firstLetter = method.name.charAt(0).toUpperCase();
    if (groupedMethods[firstLetter]) {
      groupedMethods[firstLetter].data.push(method);
    } else {
      groupedMethods[firstLetter] = { title: firstLetter, data: [method] };
    }
  });
  Object.keys(groupedMethods)
    .sort((a, b) => a.localeCompare(b))
    .forEach((letter) => {
      const letterData = groupedMethods[letter]?.data;
      if (Array.isArray(letterData)) {
        letterData.sort();
      }
    });
  const sortedObj = Object.keys(groupedMethods)
    .sort()
    .reduce((acc, key) => {
      acc[key] = groupedMethods[key];
      return acc;
    }, {});
  return {
    Popular: { title: "Popular", data: popularMethods },
    ...sortedObj,
  };
};

export const ALL_GROUPED_PAYMENT_METHODS = getMethodsGroupedByLetter();

export const setLangInAsyncStorage = async (language) => {
  // Skip null/non-string values: localStorage would save them as "null" etc.
  if (!SUPPORTED_LANGUAGES.includes(language)) return;
  try {
    await localStorage.setItem("language", language);
  } catch (e) {}
};

export const sanitizeImages = (rawImages) => {
  return Array.isArray(rawImages) ? rawImages.map(String) : [];
};

export const sanitizeAttachments = (rawImages) => {
  if (!Array.isArray(rawImages)) return [];
  return rawImages
    .map((item) => {
      if (typeof item === "string") {
        return { name: undefined, file: item, type: undefined };
      }
      return {
        name: item?.name,
        file: item?.file,
        type: item?.type,
      };
    })
    .filter((item) => !!item.file);
};

export const sanitizeFavourites = (rawFavourites) => {
  return Array.isArray(rawFavourites)
    ? rawFavourites.map(String)
    : ["udhaarbook", "cashbook", "billbook", "staffbook"];
};

export const sanitizeSmsTemplate = (rawTemplate) => {
  return rawTemplate
    ? rawTemplate
    : {
        name: true,
        bill_amount: true,
        balance: true,
        lang: "romn",
      };
};

export const handleToast = (setToastLoad = () => {}, delay = 2000) => {
  if (setToastLoad) {
    setToastLoad(true);
    let time = setTimeout(() => {
      setToastLoad(false);
    }, delay);
  }
};

export const handleGeneralToast = (
  setToastLoad = () => {},
  delay = 2000,
  info,
) => {
  if (setToastLoad) {
    setToastLoad({
      info: info,
      load: true,
    });
    let time = setTimeout(() => {
      setToastLoad({ info: info, load: false });
    }, delay);
  }
};

const SUPPORTED_LANGUAGES = ["en", "ur", "romn", "snd"];

// Stored language code, or null if missing/invalid. Older logout/relogin paths
// could store "null" or "[object Promise]", which must not reach the dropdowns.
export const getValidStoredLanguage = () => {
  const language = localStorage.getItem("language");
  return SUPPORTED_LANGUAGES.includes(language) ? language : null;
};

export const getLangFromAsyncStorage = () => {
  return new Promise((resolve, reject) => {
    const language = localStorage.getItem("language");
    if (language) {
      resolve(language);
    } else {
      resolve(language);
    }
  });
};

export let setVideoWatchedInAsyncStorage = async () => {
  try {
    await localStorage.setItem("videowatched", "watched");
  } catch (err) {}
};

export var getTodayDateObj = (today = new Date()) => {
  let dd = String(today.getDate()).padStart(2, "0");
  let mm = String(today.getMonth() + 1).padStart(2, "0");
  let yyyy = today.getFullYear();
  let obj = { day: dd, month: mm, year: yyyy };
  return obj;
};

export const formatPhoneNumber = (number) => {
  if (!number) return;
  return `${number.slice(0, 4)} ${number.slice(4, 7)} ${number.slice(7, 11)}`;
};

export const mergeJsonArrays = (array1, array2, key) => {
  const mergedArray = [];

  for (const obj1 of array1) {
    const obj2 = array2.find((o) => o[key] === obj1[key]);

    if (obj2) {
      const mergedObj = { ...obj1, schedule_status: obj2?.schedule_status }; // Merge properties
      mergedArray.push(mergedObj);
    } else {
      mergedArray.push(obj1);
    }
  }
  for (const obj2 of array2) {
    if (!mergedArray.some((mergedObj) => mergedObj[key] === obj2[key])) {
      mergedArray.push(obj2);
    }
  }
  return mergedArray;
};

export const converTextToImage = (
  text = "",
  font = "",
  fillStyle = "black",
) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  ctx.font = font || "bolder 3rem Arial";
  ctx.fillStyle = fillStyle;
  const textWidth = ctx.measureText(text).width;
  const x = (canvas.width - textWidth) / 2;
  const y = canvas.height / 2 + 15;
  ctx.fillText(text, x, y);
  ctx.textBaseline = "middle";
  return canvas.toDataURL();
};

export const getBase64FromImageURL = (imageURI = "") => {
  return imageURI.replace(/^data:image\/?[A-z]*;base64,/, "");
};

export function getBase64FromFile(file) {
  if (file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });
  } else return "";
}

export const handleUploadImage = async (file, handleSetImage) => {
  let extractedFile = Array.isArray(file) ? file[0] : file;
  const b64result = await getBase64FromFile(extractedFile);
  handleSetImage(b64result);
};

export function roundToTwoDp(num) {
  return +(Math.round(num + "e+2") + "e-2") || 0;
}

export const unitConversion = (stock, unit, qty) => {
  if (unit == stock.unit) return Number(qty);
  else return Number(Number(qty) / Number(stock?.unit_conversion));
};

export const DEFAULT_MENU_OPTION = [
  { label: "Item discount", action: () => {} },
  { label: "Remove item", action: () => {} },
];

export const AmountSuggestion = [50, 100, 500, 1000, 5000];

export const ACTIVE = "active";
export const SUCCESS = "success";
export const DRAFT = "draft";

export const unitKB = [
  {
    title: "Bags",
    value: "bags",
  },
  {
    title: "Bottles",
    value: "btl",
  },
  {
    title: "Box",
    value: "box",
  },
  {
    title: "Bundles",
    value: "bdl",
  },
  {
    title: "Cans",
    value: "cans",
  },
  {
    title: "Cartons",
    value: "ctn",
  },
  {
    title: "Dozens",
    value: "doz",
  },
  {
    title: "Feet",
    value: "ft",
  },
  {
    title: "Gallon",
    value: "gal",
  },
  {
    title: "Grams",
    value: "gm",
  },
  {
    title: "Gaz",
    value: "gaz",
  },
  {
    title: "Kilogram",
    value: "kg",
  },
  {
    title: "Litre",
    value: "ltr",
  },
  {
    title: "Meters",
    value: "m",
  },
  {
    title: "Mililitre",
    value: "ml",
  },
  {
    title: "Numbers",
    value: "nbr",
  },
  {
    title: "Pacs",
    value: "pacs",
  },
  {
    title: "Pairs",
    value: "pairs",
  },
  {
    title: "Pieces",
    value: "pcs",
  },
  {
    title: "Pound",
    value: "pound",
  },
  {
    title: "Quarter",
    value: "qtr",
  },
  {
    title: "Ream",
    value: "ream",
  },
  {
    title: "Roll",
    value: "roll",
  },
  {
    title: "Tola",
    value: "tola",
  },
  {
    title: "Thaan",
    value: "thaan",
  },
  {
    title: "Yards",
    value: "yd",
  },
];

export const unitKB_2 = [
  {
    label: "Bags (bags)",
    value: "Bags",
  },
  {
    label: "Bottles (btl)",
    value: "Bottles",
  },
  {
    label: "Box (box)",
    value: "Box",
  },
  {
    label: "Bundles (bdl)",
    value: "Bundles",
  },
  {
    label: "Cans (cans)",
    value: "Cans",
  },
  {
    label: "Cartons (ctn)",
    value: "Cartons",
  },
  {
    label: "Dozens (doz)",
    value: "Dozens",
  },
  {
    label: "Feet (ft)",
    value: "Feet",
  },
  {
    label: "Gallon (gal)",
    value: "Gallon",
  },
  {
    label: "Grams (gm)",
    value: "Grams",
  },
  {
    label: "Gaz (gaz)",
    value: "Gaz",
  },
  {
    label: "Kilogram (kg)",
    value: "Kilogram",
  },
  {
    label: "Litre (ltr)",
    value: "Litre",
  },
  {
    label: "Meters (m)",
    value: "Meters",
  },
  {
    label: "Mililitre (ml)",
    value: "Mililitre",
  },
  {
    label: "Numbers (nbr)",
    value: "Numbers",
  },
  {
    label: "Pacs (pacs)",
    value: "Pacs",
  },
  {
    label: "Pairs (pairs)",
    value: "Pairs",
  },
  {
    label: "Pieces (pcs)",
    value: "Pieces",
  },
  {
    label: "Pound (pound)",
    value: "Pound",
  },
  {
    label: "Quarter (qtr)",
    value: "Quarter",
  },
  {
    label: "Ream (ream)",
    value: "Ream",
  },
  {
    label: "Roll (roll)",
    value: "Roll",
  },
  {
    label: "Tola (tola)",
    value: "Tola",
  },
  {
    label: "Thaan (thaan)",
    value: "Thaan",
  },
  {
    label: "Yards (yd)",
    value: "Yards",
  },
];

export const STOCK_SORT = {
  nameAscending: "Name (A-Z)",
  nameDescending: "Name (Z-A)",
  priceHighToLow: "Price (High - Low)",
  priceLowToHigh: "Price (Low - High)",
};

export const cashNumKeypadAmountLimit = 1000000000;
export function isObjEmpty(obj) {
  if (typeof obj === typeof {}) {
    for (var i in obj) return false;
    return true;
  } else return true;
}

export const INVOICESORT = {
  amountHighToLow: "amountHToL",
  amountLowToHigh: "amountLToH",
  isAscendingOrder: "isAscendingOrder",
};

export const SEVERITY = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
};
export const WEIGHT_TYPES = {
  Kg: { name: "Kg", type: "kg" },
  Gram: { name: "Gram", type: "gm" },
  Lbs: { name: "Lbs", type: "lbs" },
};
export const DIMENSION_TYPES = {
  CM: { name: "CM", type: "cm" },
  Inch: { name: "Inch", type: "inch" },
  Meter: { name: "Meter", type: "meter" },
  Feet: { name: "Feet", type: "feet" },
};
export const PARCEL_TYPES = {
  Carton: { name: "Carton", type: "carton" },
  Flyer: { name: "Flyer", type: "flyer" },
};

export const TransactionFilter = ["All", "Received", "Given", "Settled"];
export const PaymentMethodFilter = ["All", "Cash", "Udhaar", "Online"];
export const PaidUnPaidFilter = ["All", "Paid", "Unpaid"];

export const DateFilter = [
  "All",
  "Today",
  "7 days",
  "15 days",
  "30 days",
  "Custom",
];
export const SortFilter = [
  "Newest",
  "Name (A - Z)",
  "Amount (Low - High)",
  "Oldest",
  "Name (Z - A)",
  "Amount (High - Low)",
];

export const SortWithoutAmountFilter = [
  "Newest",
  "Oldest",
  "Name (A - Z)",
  "Name (Z - A)",
];
export const SortWithAmountFilter = [
  "Newest",
  "Oldest",
  "Amount (Low - High)",
  "Amount (High - Low)",
];

export const SORT = {
  amountHighToLow: "Amount (High - Low)",
  amountLowToHigh: "Amount (Low - High)",
  nameAToZ: "Name (A - Z)",
  nameZToA: "Name (Z - A)",
  Newest: "Newest",
  Oldest: "Oldest",
  isAscendingOrder: "isAscendingOrder",
  unpaid: "unpaid",
  blank: "blank",
};

export const NEW_SORT = {
  amountHighToLow: "Amount (High to Low)",
  amountLowToHigh: "Amount (Low to High)",
  quantityHighToLow: "Quantity (High to Low)",
  quantityLowToHigh: "Quantity (Low to High)",
  nameAToZ: "Name (A - Z)",
  nameZToA: "Name (Z - A)",
  Newest: "Newest",
  Oldest: "Oldest",
  isAscendingOrder: "isAscendingOrder",
  unpaid: "Unpaid status",
  blank: "No status",
  paid: "Paid status",
  lowest: "Lowest",
  highest: "Highest",
  quick_sale: "Quick Sale",
  invoice: "Invoice",
  pos: "POS",
  SALE: "SALE",
  EXPENSE: "EXPENSE",
};

export const TABLE_FILTERS = [
  "Status",
  "Method",
  "Category",
  "Date",
  "Sort",
  "Amount",
  "Keywords",
];

export const TABLE_FILTERS_STOCK_MANAGEMENT = [
  "Status",
  "Visibility",
  "Keywords",
];

export const TABLE_FILTERS_LEDGER = ["Date", "Keywords"];
export const TABLE_FILTERS_ORDER_MANAGEMENT = [
  "View",
  "Status",
  "Date",
  "Keywords",
];
export const STOCK_TABLE_FILTERS = ["Items", "Sort", "Amount", "Keywords"];

export const TABLE_FILTERS_WITHOUT_CATEGORY = [
  "Status",
  "Method",
  "Date",
  "Sort",
  "Amount",
  "Keywords",
];

export const TABLE_FILTER_WITHOUT_KEYWORDS_AND_METHOD = [
  "Status",
  "Category",
  "Date",
  "Sort",
  "Amount",
];

export const TABLE_FILTER_CONTACT = [
  "Customers",
  "Type",
  "Sort",
  "Amount",
  "Keywords",
];

export const TABLE_FILTER_ACCOUNT = [
  "Type",
  "Date",
  "Sort",
  "Amount",
  "Keywords",
];

export const TABLE_FILTER_ACCOUNT_WITHOUT_KEYWORDS = [
  "Type",
  "Date",
  "Sort",
  "Amount",
];

export const TABLE_FILTER_SALES_UNIFICATION = [
  "View",
  "Status",
  "Method",
  "Date",
  "Sort",
  "Amount",
  "Keywords",
];

export const TABLE_FILTER_TXNS = ["View", "Amount", "Date", "Keywords"];
export const TABLE_FILTER_UNCATEGORIZED = [
  "Type",
  "Date",
  "Amount",
  "Keywords",
];

export const TABLE_FILTER_BUSINESS_OVERVIEW = [
  "Type",
  "Status",
  "Method",
  "Date",
  "Amount",
  "Keywords",
];

export const PaymentMode = {
  Jama: "Jama",
  Udhaar: "Udhaar",
};

export const YESNO = {
  Yes: "Yes",
  No: "No",
};
export const DIMENSIONS = {
  "15 x 15 x 6": { name: "15 x 15 x 6", type: "15 x 15 x 6" },
  "14 x 14 x 14": { name: "14 x 14 x 14", type: "14 x 14 x 14" },
  "14 x 14 x 5": { name: "14 x 14 x 5", type: "14 x 14 x 5" },
  "20 x 15 x 15": { name: "20 x 15 x 15", type: "20 x 15 x 15" },
  "14 x 8 x 5": { name: "14 x 8 x 5", type: "14 x 8 x 5" },
  "36 x 6 x 6": { name: "36 x 6 x 6", type: "36 x 6 x 6" },
};

export const messageTemplate = (payment, business, account) => {
  return `Bill from ${business}

Amount: Rs.${payment}

Bank: ${account.bankName}
Account title: ${account.accountTitle}
Account #: ${account.accountNumber}
IBAN: ${account.IBAN}

Please pay via Easypaisa, JazzCash, or any bank transfer.

Details: ${process.env.REACT_APP_WEB_DOMAIN || "https://web.rupin.pk"}/qr/${account?.qr_share_key}
`;
};

export const miniPdfStatementTemplate = (link) => {
  return `here is your pdf link ${link}`;
};

export const CATEGORY_LIST = [
  {
    name: "Kiryana / mini-mart",
  },
  {
    name: "Cafe / Bakery",
  },
  {
    name: "Medical store",
  },
  {
    name: "Book shop",
  },
  {
    name: "Apparels / Garment store",
  },
  {
    name: "Electronics / Mobile store",
  },
  {
    name: "Careem / Uber",
  },
  {
    name: "Mobile recharge / Easypaisa store",
  },
  {
    name: "Wholeseller / Distributor",
  },
  {
    name: "Pan shop",
  },
  {
    name: "Generator Parts",
  },
  {
    name: "Bike Parts",
  },
  {
    name: "Other",
  },
];

export const ExpenseCategoryList = [
  { label: "Rent", value: "Rent", img: null },
  { label: "Electricity Bill", value: "Electricity Bill", img: null },
  { label: "Gas Bill", value: "Gas Bill", img: null },
  { label: "Water Bill", value: "Water Bill", img: null },
  { label: "Internet Bill", value: "Internet Bill", img: null },
  { label: "Grocery & Food", value: "Grocery & Food", img: null },
  {
    label: "Mobile Packages",
    value: "Mobile Packages",
    img: null,
  },
  { label: "Transport", value: "Transport", img: null },
  { label: "Fuel", value: "Fuel", img: null },
  { label: "Maintenance", value: "Maintenance", img: null },
  { label: "Health", value: "Health", img: null },
  { label: "Charity", value: "Charity", img: null },
  { label: "Entertainment", value: "Entertainment", img: null },
  { label: "Miscellaneous", value: "Miscellaneous", img: null },
];

export const CompaniesList = [
  {
    label: "A. F. Ferguson & Co.",
    value: "A. F. Ferguson & Co.",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Adamjee Group",
    value: "Adamjee Group",
    img: "",
    isInitalLetter: true,
  },
  { label: "Aero Asia", value: "Aero Asia", img: "", isInitalLetter: true },
  {
    label: "Agha's Supermarker",
    value: "Agha's Supermarker",
    img: "",
    isInitalLetter: true,
  },
  { label: "Air Indus", value: "Air Indus", img: "", isInitalLetter: true },
  { label: "Airblue", value: "Airblue", img: "", isInitalLetter: true },
  { label: "AirSial", value: "AirSial", img: "", isInitalLetter: true },
  {
    label: "Aisha Steel Mills",
    value: "Aisha Steel Mills",
    img: "",
    isInitalLetter: true,
  },
  { label: "AKD Group", value: "AKD Group", img: "", isInitalLetter: true },
  {
    label: "Al Haj FAW Motors",
    value: "Al Haj FAW Motors",
    img: "",
    isInitalLetter: true,
  },
  { label: "Al-Fatah", value: "Al-Fatah", img: "", isInitalLetter: true },
  {
    label: "Al-Ghazi Tractors",
    value: "Al-Ghazi Tractors",
    img: "",
    isInitalLetter: true,
  },
  { label: "Allied Bank", value: "Allied Bank", img: "", isInitalLetter: true },
  { label: "Amir Adnan", value: "Amir Adnan", img: "", isInitalLetter: true },
  {
    label: "Amreli Steels",
    value: "Amreli Steels",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Arif Habib Corporation",
    value: "Arif Habib Corporation",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Army Welfare Trust",
    value: "Army Welfare Trust",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "ARY Digital Network",
    value: "ARY Digital Network",
    img: "",
    isInitalLetter: true,
  },
  { label: "Askari Bank", value: "Askari Bank", img: "", isInitalLetter: true },
  {
    label: "Associated Group",
    value: "Associated Group",
    img: "",
    isInitalLetter: true,
  },
  { label: "At-Tahur", value: "At-Tahur", img: "", isInitalLetter: true },
  { label: "Atlas Group", value: "Atlas Group", img: "", isInitalLetter: true },
  { label: "Atlas Honda", value: "Atlas Honda", img: "", isInitalLetter: true },
  {
    label: "Attock Cement",
    value: "Attock Cement",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Attock Petroleum",
    value: "Attock Petroleum",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Attock Refinery",
    value: "Attock Refinery",
    img: "",
    isInitalLetter: true,
  },
  { label: "Avanceon", value: "Avanceon", img: "", isInitalLetter: true },
  {
    label: "Avari Hotels",
    value: "Avari Hotels",
    img: "",
    isInitalLetter: true,
  },
  { label: "Axact", value: "Axact", img: "", isInitalLetter: true },
  {
    label: "Bahria Foundation",
    value: "Bahria Foundation",
    img: "",
    isInitalLetter: true,
  },
  { label: "Bahria Town", value: "Bahria Town", img: "", isInitalLetter: true },
  {
    label: "Bank AL Habib",
    value: "Bank AL Habib",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Bank Alfalah",
    value: "Bank Alfalah",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Bank Makramah",
    value: "Bank Makramah",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Bank of Azad Jammu & Kashmir",
    value: "Bank of Azad Jammu & Kashmir",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Bank of Credit and Commerce International",
    value: "Bank of Credit and Commerce International",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Bank of Khyber",
    value: "Bank of Khyber",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Bank of Punjab",
    value: "Bank of Punjab",
    img: "",
    isInitalLetter: true,
  },
  { label: "BankIslami", value: "BankIslami", img: "", isInitalLetter: true },
  { label: "Bareezé", value: "Bareezé", img: "", isInitalLetter: true },
  {
    label: "Bestway Cement",
    value: "Bestway Cement",
    img: "",
    isInitalLetter: true,
  },
  { label: "Bhoja Air", value: "Bhoja Air", img: "", isInitalLetter: true },
  {
    label: "Bibojee Group",
    value: "Bibojee Group",
    img: "",
    isInitalLetter: true,
  },
  { label: "BOL Network", value: "BOL Network", img: "", isInitalLetter: true },
  {
    label: "Brighto Paints",
    value: "Brighto Paints",
    img: "",
    isInitalLetter: true,
  },
  { label: "Burger King", value: "Burger King", img: "", isInitalLetter: true },
  { label: "Burj Bank", value: "Burj Bank", img: "", isInitalLetter: true },
  {
    label: "Business Recorder",
    value: "Business Recorder",
    img: "",
    isInitalLetter: true,
  },
  { label: "Bykea", value: "Bykea", img: "", isInitalLetter: true },
  { label: "CA Sports", value: "CA Sports", img: "", isInitalLetter: true },
  { label: "Caltex", value: "Caltex", img: "", isInitalLetter: true },
  { label: "Careem", value: "Careem", img: "", isInitalLetter: true },
  { label: "Chase Up", value: "Chase Up", img: "", isInitalLetter: true },
  { label: "Cheezious", value: "Cheezious", img: "", isInitalLetter: true },
  {
    label: "Chenab Limited",
    value: "Chenab Limited",
    img: "",
    isInitalLetter: true,
  },
  { label: "Cnergyico", value: "Cnergyico", img: "", isInitalLetter: true },
  {
    label: "Colgate-Palmolive Pakistan",
    value: "Colgate-Palmolive Pakistan",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "CSD Pakistan",
    value: "CSD Pakistan",
    img: "",
    isInitalLetter: true,
  },
  { label: "Daily Jang", value: "Daily Jang", img: "", isInitalLetter: true },
  { label: "Dalda", value: "Dalda", img: "", isInitalLetter: true },
  { label: "Daraaz", value: "Daraaz", img: "", isInitalLetter: true },
  { label: "Dawlance", value: "Dawlance", img: "", isInitalLetter: true },
  {
    label: "Dawn Media Group",
    value: "Dawn Media Group",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Defence Housing Authority",
    value: "Defence Housing Authority",
    img: "",
    isInitalLetter: true,
  },
  { label: "Descon", value: "Descon", img: "", isInitalLetter: true },
  {
    label: "Dewan Farooque Motors",
    value: "Dewan Farooque Motors",
    img: "",
    isInitalLetter: true,
  },
  { label: "DG Cement", value: "DG Cement", img: "", isInitalLetter: true },
  { label: "Dolmen", value: "Dolmen", img: "", isInitalLetter: true },
  { label: "Dominos", value: "Dominos", img: "", isInitalLetter: true },
  { label: "DWatson", value: "DWatson", img: "", isInitalLetter: true },
  {
    label: "DYL Motorcycles",
    value: "DYL Motorcycles",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "EFU Insurance",
    value: "EFU Insurance",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "English Biscuit Manufacturers",
    value: "English Biscuit Manufacturers",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Engro Corporation",
    value: "Engro Corporation",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Engro Fertilizers",
    value: "Engro Fertilizers",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Engro Holdings",
    value: "Engro Holdings",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Engro Polymer",
    value: "Engro Polymer",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Eveready Pictures",
    value: "Eveready Pictures",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Faisal Movers",
    value: "Faisal Movers",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Fatima Group",
    value: "Fatima Group",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Fauji Fertilizer Company",
    value: "Fauji Fertilizer Company",
    img: "",
    isInitalLetter: true,
  },
  { label: "Fauji Foods", value: "Fauji Foods", img: "", isInitalLetter: true },
  {
    label: "Fauji Foundation",
    value: "Fauji Foundation",
    img: "",
    isInitalLetter: true,
  },
  { label: "Faysal Bank", value: "Faysal Bank", img: "", isInitalLetter: true },
  { label: "Fecto Group", value: "Fecto Group", img: "", isInitalLetter: true },
  { label: "Ferozsons", value: "Ferozsons", img: "", isInitalLetter: true },
  {
    label: "First Women Bank",
    value: "First Women Bank",
    img: "",
    isInitalLetter: true,
  },
  { label: "Fly Jinnah", value: "Fly Jinnah", img: "", isInitalLetter: true },
  { label: "Foodpanda", value: "Foodpanda", img: "", isInitalLetter: true },
  {
    label: "Forward Sports",
    value: "Forward Sports",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "FrieslandCampina Engro Pakistan",
    value: "FrieslandCampina Engro Pakistan",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Frontier Works Organization",
    value: "Frontier Works Organization",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Geo Television Network",
    value: "Geo Television Network",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Ghandhara Automobiles",
    value: "Ghandhara Automobiles",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Ghandhara Isuzu",
    value: "Ghandhara Isuzu",
    img: "",
    isInitalLetter: true,
  },
  { label: "Ghani Group", value: "Ghani Group", img: "", isInitalLetter: true },
  {
    label: "Global Industrial Defence Solutions",
    value: "Global Industrial Defence Solutions",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Gourmet Foods",
    value: "Gourmet Foods",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "GSK Pakistan",
    value: "GSK Pakistan",
    img: "",
    isInitalLetter: true,
  },
  { label: "GTR", value: "GTR", img: "", isInitalLetter: true },
  { label: "Gul Ahmed", value: "Gul Ahmed", img: "", isInitalLetter: true },
  {
    label: "Gwadar Port Authority",
    value: "Gwadar Port Authority",
    img: "",
    isInitalLetter: true,
  },
  { label: "Habib Bank", value: "Habib Bank", img: "", isInitalLetter: true },
  { label: "HabibMetro", value: "HabibMetro", img: "", isInitalLetter: true },
  {
    label: "Hamdard Laboratories",
    value: "Hamdard Laboratories",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Hascol Petroleum",
    value: "Hascol Petroleum",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Hashoo Group",
    value: "Hashoo Group",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Heavy Electrical Complex",
    value: "Heavy Electrical Complex",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Heavy Industries Taxila",
    value: "Heavy Industries Taxila",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Heavy Mechanical Complex",
    value: "Heavy Mechanical Complex",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Hinopak Motors",
    value: "Hinopak Motors",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Honda Atlas Cars",
    value: "Honda Atlas Cars",
    img: "",
    isInitalLetter: true,
  },
  { label: "Hot n spicy", value: "Hot n spicy", img: "", isInitalLetter: true },
  {
    label: "House of Habib",
    value: "House of Habib",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Hub Power Company",
    value: "Hub Power Company",
    img: "",
    isInitalLetter: true,
  },
  { label: "Hum Network", value: "Hum Network", img: "", isInitalLetter: true },
  {
    label: "Hyperstar Pakistan",
    value: "Hyperstar Pakistan",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Hyundai Nishat Motors",
    value: "Hyundai Nishat Motors",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Imtiaz Super Market",
    value: "Imtiaz Super Market",
    img: "",
    isInitalLetter: true,
  },
  { label: "In-Drive", value: "In-Drive", img: "", isInitalLetter: true },
  { label: "Indus Motor", value: "Indus Motor", img: "", isInitalLetter: true },
  {
    label: "Industrial Development Bank",
    value: "Industrial Development Bank",
    img: "",
    isInitalLetter: true,
  },
  { label: "Instaphone", value: "Instaphone", img: "", isInitalLetter: true },
  {
    label: "Integrated Dynamics",
    value: "Integrated Dynamics",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Interloop Limited",
    value: "Interloop Limited",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "International Steels Limited",
    value: "International Steels Limited",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Ismail Industries",
    value: "Ismail Industries",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Ittefaq Group",
    value: "Ittefaq Group",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Ittefaq Iron Industries",
    value: "Ittefaq Iron Industries",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Ittehad Chemicals",
    value: "Ittehad Chemicals",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Jang Media Group",
    value: "Jang Media Group",
    img: "",
    isInitalLetter: true,
  },
  { label: "Javedan", value: "Javedan", img: "", isInitalLetter: true },
  { label: "Jazz", value: "Jazz", img: "", isInitalLetter: true },
  { label: "JS Bank", value: "JS Bank", img: "", isInitalLetter: true },
  { label: "JS Group", value: "JS Group", img: "", isInitalLetter: true },
  {
    label: "Jubilee Insurance",
    value: "Jubilee Insurance",
    img: "",
    isInitalLetter: true,
  },
  { label: "K-Electric", value: "K-Electric", img: "", isInitalLetter: true },
  { label: "K&N's", value: "K&N's", img: "", isInitalLetter: true },
  {
    label: "Karachi Port Trust",
    value: "Karachi Port Trust",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Karachi Shipyard",
    value: "Karachi Shipyard",
    img: "",
    isInitalLetter: true,
  },
  { label: "KASB Bank", value: "KASB Bank", img: "", isInitalLetter: true },
  { label: "Kaymu.pk", value: "Kaymu.pk", img: "", isInitalLetter: true },
  { label: "KFC", value: "KFC", img: "", isInitalLetter: true },
  { label: "Khaadi", value: "Khaadi", img: "", isInitalLetter: true },
  {
    label: "Kohat Cement",
    value: "Kohat Cement",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Kot Addu Power",
    value: "Kot Addu Power",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Lahore Electric Supply Company (LESCO)",
    value: "Lahore Electric Supply Company (LESCO)",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Lakson Group",
    value: "Lakson Group",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Lalpir Power",
    value: "Lalpir Power",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Leopards Courier",
    value: "Leopards Courier",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Loads Limited",
    value: "Loads Limited",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Lotte Chemical Pakistan",
    value: "Lotte Chemical Pakistan",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Lotte Kolson",
    value: "Lotte Kolson",
    img: "",
    isInitalLetter: true,
  },
  { label: "LSE Group", value: "LSE Group", img: "", isInitalLetter: true },
  {
    label: "Lucky Cement",
    value: "Lucky Cement",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Lucky Core Industries",
    value: "Lucky Core Industries",
    img: "",
    isInitalLetter: true,
  },
  { label: "Lucky Motor", value: "Lucky Motor", img: "", isInitalLetter: true },
  { label: "MangoBaaz", value: "MangoBaaz", img: "", isInitalLetter: true },
  {
    label: "Maple Leaf Cement",
    value: "Maple Leaf Cement",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Mari Energies",
    value: "Mari Energies",
    img: "",
    isInitalLetter: true,
  },
  { label: "Maria B", value: "Maria B", img: "", isInitalLetter: true },
  { label: "Martin Dow", value: "Martin Dow", img: "", isInitalLetter: true },
  {
    label: "Masood Textile Mills",
    value: "Masood Textile Mills",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Master Motors",
    value: "Master Motors",
    img: "",
    isInitalLetter: true,
  },
  { label: "MCB Bank", value: "MCB Bank", img: "", isInitalLetter: true },
  { label: "McDonald's", value: "McDonald's", img: "", isInitalLetter: true },
  { label: "Meezan Bank", value: "Meezan Bank", img: "", isInitalLetter: true },
  {
    label: "Metro Cash & Carry",
    value: "Metro Cash & Carry",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "MG Motors Pakistan",
    value: "MG Motors Pakistan",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Millat Tractors",
    value: "Millat Tractors",
    img: "",
    isInitalLetter: true,
  },
  { label: "Mitchell's", value: "Mitchell's", img: "", isInitalLetter: true },
  {
    label: "Mughal Steel",
    value: "Mughal Steel",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Muhammadi Steamship",
    value: "Muhammadi Steamship",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Murree Brewery",
    value: "Murree Brewery",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Naheed Supermarket",
    value: "Naheed Supermarket",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "National Bank of Pakistan",
    value: "National Bank of Pakistan",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "National Engineering and Scientific Commission",
    value: "National Engineering and Scientific Commission",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "National Foods",
    value: "National Foods",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "National Logistics Corporation",
    value: "National Logistics Corporation",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "National Radio & Telecommunication Corporation",
    value: "National Radio & Telecommunication Corporation",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "National Refinery",
    value: "National Refinery",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "National Transmission & Dispatch Company",
    value: "National Transmission & Dispatch Company",
    img: "",
    isInitalLetter: true,
  },
  { label: "Nayatel", value: "Nayatel", img: "", isInitalLetter: true },
  { label: "NESPAK", value: "NESPAK", img: "", isInitalLetter: true },
  {
    label: "Nestlé Pakistan",
    value: "Nestlé Pakistan",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Network Television Marketing",
    value: "Network Television Marketing",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Nexus Automotive",
    value: "Nexus Automotive",
    img: "",
    isInitalLetter: true,
  },
  { label: "NIB Bank", value: "NIB Bank", img: "", isInitalLetter: true },
  {
    label: "Nishat Group",
    value: "Nishat Group",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Nishat Mills Limited",
    value: "Nishat Mills Limited",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Oil & Gas Development Company",
    value: "Oil & Gas Development Company",
    img: "",
    isInitalLetter: true,
  },
  { label: "OPTP", value: "OPTP", img: "", isInitalLetter: true },
  {
    label: "Pace Pakistan",
    value: "Pace Pakistan",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Packages Limited",
    value: "Packages Limited",
    img: "",
    isInitalLetter: true,
  },
  { label: "Pak Datacom", value: "Pak Datacom", img: "", isInitalLetter: true },
  {
    label: "Pak Suzuki Motors",
    value: "Pak Suzuki Motors",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pak-Arab Refinery",
    value: "Pak-Arab Refinery",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan Aeronautical Complex",
    value: "Pakistan Aeronautical Complex",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan Atomic Energy Commission",
    value: "Pakistan Atomic Energy Commission",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan Chrome Mines",
    value: "Pakistan Chrome Mines",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan Electric Power Company",
    value: "Pakistan Electric Power Company",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan Engineering Company",
    value: "Pakistan Engineering Company",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan Gems and Jewellery Development Company",
    value: "Pakistan Gems and Jewellery Development Company",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan Industrial Credit and Investment Corporation",
    value: "Pakistan Industrial Credit and Investment Corporation",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan Industrial Development Corporation",
    value: "Pakistan Industrial Development Corporation",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan International Airlines",
    value: "Pakistan International Airlines",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan International Container Terminal",
    value: "Pakistan International Container Terminal",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan Locomotive Factory",
    value: "Pakistan Locomotive Factory",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan Mineral Development Corporation",
    value: "Pakistan Mineral Development Corporation",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan Mineral Water Bottling Plant",
    value: "Pakistan Mineral Water Bottling Plant",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan National Shipping Corporation",
    value: "Pakistan National Shipping Corporation",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan Oilfields Limited",
    value: "Pakistan Oilfields Limited",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan Ordnance Factories",
    value: "Pakistan Ordnance Factories",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan Petroleum",
    value: "Pakistan Petroleum",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan Post",
    value: "Pakistan Post",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan Railways",
    value: "Pakistan Railways",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan Refinery",
    value: "Pakistan Refinery",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan State Oil",
    value: "Pakistan State Oil",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan Steel Mills",
    value: "Pakistan Steel Mills",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Pakistan Television Corporation",
    value: "Pakistan Television Corporation",
    img: "",
    isInitalLetter: true,
  },
  { label: "Pakola", value: "Pakola", img: "", isInitalLetter: true },
  { label: "Paktel", value: "Paktel", img: "", isInitalLetter: true },
  { label: "PakWheels", value: "PakWheels", img: "", isInitalLetter: true },
  {
    label: "Pearl-Continental Hotels & Resorts",
    value: "Pearl-Continental Hotels & Resorts",
    img: "",
    isInitalLetter: true,
  },
  { label: "PEL", value: "PEL", img: "", isInitalLetter: true },
  {
    label: "Peshawar Electric Supply Company (PESCO)",
    value: "Peshawar Electric Supply Company (PESCO)",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "PHA Foundation",
    value: "PHA Foundation",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "PICIC Commercial Bank",
    value: "PICIC Commercial Bank",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Port Qasim Authority",
    value: "Port Qasim Authority",
    img: "",
    isInitalLetter: true,
  },
  { label: "PTCL", value: "PTCL", img: "", isInitalLetter: true },
  { label: "QMobile", value: "QMobile", img: "", isInitalLetter: true },
  { label: "Rastah", value: "Rastah", img: "", isInitalLetter: true },
  { label: "Rayyan Air", value: "Rayyan Air", img: "", isInitalLetter: true },
  { label: "Saif Group", value: "Saif Group", img: "", isInitalLetter: true },
  {
    label: "Saigol Group",
    value: "Saigol Group",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Saindak Metals",
    value: "Saindak Metals",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Sana Safinaz",
    value: "Sana Safinaz",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Sapphire Retail",
    value: "Sapphire Retail",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Sapphire Textile",
    value: "Sapphire Textile",
    img: "",
    isInitalLetter: true,
  },
  { label: "Sazgar", value: "Sazgar", img: "", isInitalLetter: true },
  { label: "SereneAir", value: "SereneAir", img: "", isInitalLetter: true },
  {
    label: "Servis Industries Limited",
    value: "Servis Industries Limited",
    img: "",
    isInitalLetter: true,
  },
  { label: "Shaheen Air", value: "Shaheen Air", img: "", isInitalLetter: true },
  {
    label: "Shaheen Chemist",
    value: "Shaheen Chemist",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Shaheen Foundation",
    value: "Shaheen Foundation",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Shakarganj Limited",
    value: "Shakarganj Limited",
    img: "",
    isInitalLetter: true,
  },
  { label: "Shan Foods", value: "Shan Foods", img: "", isInitalLetter: true },
  {
    label: "Sharif Group",
    value: "Sharif Group",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Shell Pakistan",
    value: "Shell Pakistan",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Shezan International",
    value: "Shezan International",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Shifa International Hospitals",
    value: "Shifa International Hospitals",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Siemens Pakistan",
    value: "Siemens Pakistan",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Sigma Motors",
    value: "Sigma Motors",
    img: "",
    isInitalLetter: true,
  },
  { label: "Silkbank", value: "Silkbank", img: "", isInitalLetter: true },
  { label: "Sindh Bank", value: "Sindh Bank", img: "", isInitalLetter: true },
  {
    label: "Sindh Engro Coal Mining Company",
    value: "Sindh Engro Coal Mining Company",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Sohrab Cycles",
    value: "Sohrab Cycles",
    img: "",
    isInitalLetter: true,
  },
  { label: "Soneri Bank", value: "Soneri Bank", img: "", isInitalLetter: true },
  {
    label: "South City Hospital",
    value: "South City Hospital",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Standard Chartered Pakistan",
    value: "Standard Chartered Pakistan",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "State Bank of Pakistan",
    value: "State Bank of Pakistan",
    img: "",
    isInitalLetter: true,
  },
  { label: "State Life", value: "State Life", img: "", isInitalLetter: true },
  { label: "Subway", value: "Subway", img: "", isInitalLetter: true },
  {
    label: "Sui Northern Gas Pipelines",
    value: "Sui Northern Gas Pipelines",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Sui Southern Gas Company",
    value: "Sui Southern Gas Company",
    img: "",
    isInitalLetter: true,
  },
  { label: "SUPARCO", value: "SUPARCO", img: "", isInitalLetter: true },
  {
    label: "Super Asia Group",
    value: "Super Asia Group",
    img: "",
    isInitalLetter: true,
  },
  { label: "Systems Ltd", value: "Systems Ltd", img: "", isInitalLetter: true },
  { label: "Tapal Tea", value: "Tapal Tea", img: "", isInitalLetter: true },
  { label: "TCS Courier", value: "TCS Courier", img: "", isInitalLetter: true },
  { label: "Telenor", value: "Telenor", img: "", isInitalLetter: true },
  {
    label: "The Express Tribune",
    value: "The Express Tribune",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "The News International",
    value: "The News International",
    img: "",
    isInitalLetter: true,
  },
  { label: "Total Parco", value: "Total Parco", img: "", isInitalLetter: true },
  {
    label: "TPL Properties",
    value: "TPL Properties",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "TPS Pakistan",
    value: "TPS Pakistan",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Treet Corporation",
    value: "Treet Corporation",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "TRG Pakistan",
    value: "TRG Pakistan",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Tuwairqi Steel Mills",
    value: "Tuwairqi Steel Mills",
    img: "",
    isInitalLetter: true,
  },
  { label: "Ufone", value: "Ufone", img: "", isInitalLetter: true },
  {
    label: "Unilever Pakistan",
    value: "Unilever Pakistan",
    img: "",
    isInitalLetter: true,
  },
  { label: "Union Bank", value: "Union Bank", img: "", isInitalLetter: true },
  {
    label: "United Auto Industries",
    value: "United Auto Industries",
    img: "",
    isInitalLetter: true,
  },
  { label: "United Bank", value: "United Bank", img: "", isInitalLetter: true },
  { label: "Unity Foods", value: "Unity Foods", img: "", isInitalLetter: true },
  {
    label: "Utility Stores Corporation",
    value: "Utility Stores Corporation",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Volvo Pakistan",
    value: "Volvo Pakistan",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Wafi Energy Pakistan",
    value: "Wafi Energy Pakistan",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Water and Power Development Authority",
    value: "Water and Power Development Authority",
    img: "",
    isInitalLetter: true,
  },
  { label: "wi-tribe", value: "wi-tribe", img: "", isInitalLetter: true },
  { label: "WorldCall", value: "WorldCall", img: "", isInitalLetter: true },
  { label: "Yango", value: "Yango", img: "", isInitalLetter: true },
  {
    label: "Yousuf Dewan Companies",
    value: "Yousuf Dewan Companies",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Yunus Brothers Group",
    value: "Yunus Brothers Group",
    img: "",
    isInitalLetter: true,
  },
  {
    label: "Zarai Taraqiati Bank",
    value: "Zarai Taraqiati Bank",
    img: "",
    isInitalLetter: true,
  },
  { label: "Zong", value: "Zong", img: "", isInitalLetter: true },
];

export const EasyloadAndPackages = {
  EASYLOAD: "Easyload",
  PACKAGES: "Packages",
};

export const EMIONBOARDINGSTATUS = {
  VERIFIED: "VERIFIED",
  NOTSTARTED: "NOT-STARTED",
  SUBMITTED: "SUBMITTED",
  RESUBMIT: "RESUBMIT",
  INPROGRESS: "IN-PROGRESS",
};
export const VERIFIED = {
  VERIFIED: "VERIFIED",
  NOTVERIFIED: "NOTVERIFIED",
  PENDING: "PENDING",
};

export const DEFAULT_DATE_FILTERS = ["5 days", "10 days", "15 days", "30 days"];

export const DEFAULT_DATE_FILTERS_EXPORT = [
  "7 days",
  "14 days",
  "30 days",
  "All",
];

export const DEFAULT_DATE_FILTERS_REPORTS = [
  "Today",
  "7 days",
  "30 days",
  "Yearly",
];

export const DATE_FILTERS_BANK_STATEMENT = [
  "This month",
  "Last 3 months",
  "Last 6 months",
  "Last 12 months",
];

export const ITEMS_PER_PAGE = 30;

export const statusColor = {
  pending: "mustardYellowShadeColor",
  delivered: "darkOrangeColor",
  ready_to_ship: "brightGreenColor",
  rejected: "brightOrangeColor",
  returned: "barclayBlueColor",
  pending_on_customer: "extraBrightPurpleColor",
  shipped: "mustardYellowShadeColor",
  cancelled: "darkOrangeColor",
  accepted: "darkGreeColor",
  IN_PROGRESS: "mustardYellowShadeColor",
  GENERATED: "brightGreenColor",
};

export const NEW_CATEGORY_LIST = [
  {
    label: "Kiryana / mini-mart",
    value: "Kiryana / mini-mart",
  },
  {
    label: "Cafe / Bakery",
    value: "Cafe / Bakery",
  },
  {
    label: "Medical store",
    value: "Medical store",
  },
  {
    label: "Book shop",
    value: "Book shop",
  },
  {
    label: "Apparels / Garment store",
    value: "Apparels / Garment store",
  },
  {
    label: "Electronics / Mobile store",
    value: "Electronics / Mobile store",
  },
  {
    label: "Careem / Uber",
    value: "Careem / Uber",
  },
  {
    label: "Mobile recharge / Easypaisa store",
    value: "Mobile recharge / Easypaisa store",
  },
  {
    label: "Wholeseller / Distributor",
    value: "Wholeseller / Distributor",
  },
  {
    label: "Pan shop",
    value: "Pan shop",
  },
  {
    label: "Generator Parts",
    value: "Generator Parts",
  },
  {
    label: "Bike Parts",
    value: "Bike Parts",
  },
  {
    label: "Other",
    value: "Other",
  },
];
